__webpack_require__.p = "/QR-scanner-and-reader/";